import template from './alert.html';
import AlertController from './alert.controller';
import './alert.less';

const AlertComponent = {
  bindings: {
    // can be: 'primary', 'success', 'info', 'warning', 'danger', 'custom', 'custom-dark'
    // see http://xserver.wg.dir.telstra.com/tcom-aem-multi/master/tcom-aem-frontend/dist/tcom-core/alert.html
    alertType: '@',
    alertMessage: '<',
    // when the parent needs to be notified of the close event
    closeCallback: '&',
    // the name of the icon to display to the left of the alert
    icon: '@',
    fullWidth: '<',
  },
  template,
  controller: AlertController
};

export default AlertComponent;



// WEBPACK FOOTER //
// ./src/components/alert/alert.component.js